// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottomBarDiv {
    border-top: 1px solid var(--light-neutral-3);
    background: var(--light-neutral-4);
    margin-top: auto;
}

.optionsWrapperDiv {
    margin-top: 1.5rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 12px;
}`, "",{"version":3,"sources":["webpack://./src/Core/Components/BottomBar/BottomBar.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,kCAAkC;IAClC,SAAS;AACb","sourcesContent":[".bottomBarDiv {\n    border-top: 1px solid var(--light-neutral-3);\n    background: var(--light-neutral-4);\n    margin-top: auto;\n}\n\n.optionsWrapperDiv {\n    margin-top: 1.5rem;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(2, 1fr);\n    gap: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
